// extracted by mini-css-extract-plugin
export default {"label":"textarea_label__piozt","textarea-container":"textarea_textarea-container__LLNam","textarea":"textarea_textarea__lJXTJ","input":"textarea_input__nL3Og"};